import { mergeStyleSets } from "office-ui-fabric-react/lib/Styling";

export const classes = mergeStyleSets({
	loginWrapper: {
		display: "flex",
		height: "100vh",
		width: "100vw",
	},
	centerContent: {
		alignSelf: "center",
		margin: "0 auto",
		textAlign: "center"
	},
	errorImage: {
		width: 400,
		height: "auto",
	},
	errorTitle: {
		fontWeight: "normal"
	}
});
